import { ResponseDefect } from './core/response';
/** Reference adapter for a conforming endpoint, also used by transport contract tests. */
export function createPositionPageAdapter(rows) {
    return {
        ...rows,
        toRequest(instruction) {
            const base = { symbols: instruction.symbols, query: instruction.query };
            switch (instruction.kind) {
                case 'initial':
                    return { ...base, kind: 'initial', limit: instruction.expectedCount };
                case 'up':
                case 'down':
                    return {
                        ...base,
                        kind: instruction.kind,
                        position: instruction.position,
                        limit: instruction.expectedCount,
                    };
                case 'backfill':
                    return {
                        ...base,
                        kind: 'backfill',
                        newest: instruction.newestCursor,
                        oldest: instruction.oldestCursor,
                        page: instruction.page,
                        limit: instruction.limit,
                    };
                case 'lead':
                    return { ...base, kind: 'lead', page: instruction.page, limit: instruction.limit };
            }
        },
        fromResponse(instruction, response) {
            if (instruction.kind !== response.kind)
                throw new ResponseDefect('Endpoint returned the wrong page kind');
            for (const row of response.rows) {
                if (!rows.keyOf(row) || rows.symbolsOf(row).length === 0) {
                    throw new ResponseDefect('Endpoint row lacks identity or symbols');
                }
                rows.calendarDateOf(row);
                rows.cursorOf(row);
            }
            const mapped = response.rows;
            switch (response.kind) {
                case 'initial':
                    return {
                        kind: 'initial',
                        rows: mapped,
                        caughtUp: !response.hasNewer,
                        reachedEnd: !response.hasOlder,
                    };
                case 'up':
                    return { kind: 'up', rows: mapped, caughtUp: !response.hasMore };
                case 'down':
                    return { kind: 'down', rows: mapped, reachedEnd: !response.hasMore };
                case 'backfill':
                case 'lead':
                    return { kind: response.kind, rows: mapped, complete: !response.hasMore };
            }
        },
    };
}
//# sourceMappingURL=endpoint.js.map